"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import i18n from "@/lang";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormAnnotations, UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
export class EditTOTPForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.totp_name = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("edittotpnamedialog.edit_totp_form.edit_name_empty_tip"),
    trigger: "blur"
  }])
], EditTOTPForm.prototype, "totp_name", 2);
let EditTOTPNameDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.formcontroller = new EditTOTPForm();
    this.dialogLoading = false;
    this.rowData = null;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  submit() {
    return __async(this, null, function* () {
      this.rowData.totp_name = this.formcontroller.totp_name;
      this.$emit("editTOTPName", { "name": this.formcontroller.totp_name });
      this.close();
    });
  }
  open(row) {
    return __async(this, null, function* () {
      this.rowData = row;
      this.formcontroller.totp_name = row.totp_name;
      this.dialog.visible = true;
    });
  }
  cancelEdit() {
    this.formcontroller.totp_name = "";
    this.close();
  }
  close() {
    this.dialog.visible = false;
  }
};
EditTOTPNameDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiForm,
      UiSubmit
    }
  })
], EditTOTPNameDialog);
export {
  EditTOTPNameDialog as default
};
